module.exports = __webpack_public_path__ + "static/img/layers1.79aa9c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layers1.jpg
// module id = jQUa
// module chunks = 1